import { Inject, Injectable, Type } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '@libs/shared/common';
import { map, Observable } from 'rxjs';
import { CONFIRMATION_DIALOG_COMPONENT_TYPE, ConfirmationDialogData } from './confirmation-dialog.model';

@Injectable()
export class ConfirmationDialogService {
  public constructor(
    @Inject(CONFIRMATION_DIALOG_COMPONENT_TYPE) private readonly componentCtr: Type<unknown>,
    public dialog: DialogService,
  ) {
  }

  public open(data: ConfirmationDialogData): Observable<boolean> {
    const dialogRef: MatDialogRef<unknown> = this.dialog.open(
      this.componentCtr,
      { data },
    );

    return dialogRef.afterClosed().pipe(
      map(Boolean),
    );
  }
}
